import { useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'global',
    viewPath: props.viewPath,
  })

  return async function onChange(next) {
    if (!next) return

    change(inext => {
      if (next.id !== inext.tab_id) return

      inext.tabs = inext.tabs.map(item => (item.id === next.id ? next : item))
    })
  }
}
